export default __webpack_public_path__ + "static/media/horse.3d52056f.png";